export default __webpack_public_path__ + "static/puerto-7514d8ecf8ddae210cd681f1cf9f4093.jpg";